import { useUserDetails } from 'app/components/user-details/useUserDetails'
import { UserDetailsComponent } from 'app/components/user-details/UserDetailsComponent'
import { editUserValidator, newUserValidatorClient } from 'app/components/user-details/userDetailsValidators'

export const handle = {
  title: `Users`,
  pathname: `/settings/users/`,
}

export default function DetailView() {
  const props = useUserDetails()
  return (
    <UserDetailsComponent
      {...props}
      editUserValidator={editUserValidator}
      newUserValidatorClient={newUserValidatorClient}
    />
  )
}
